export var theme = {
  breakpoints: {
    mobile: 480,
    tablet: 800,
    desktop: 1200,
    all: Infinity
  },
  rowGap: 24,
  maxWidth: 1140,
  zIndex: {
    tableDropdown: '1',
    tableOverlay: '2',
    dropdown: '3',
    toast: '4'
  },
  color: {
    grey: {
      dark: '#828282',
      light: '#EDEDED',
      mid: '#BFBFBF',
      white: '#F4F4F4',
      whiteGrey: '#F7F7F7',
      whiterGrey: '#F9F9F9'
    },
    primary: {
      blue: '#2C4B6E',
      darkBlue: '#15293F',
      green: '#C2E812',
      armyGreen: '#5AA700',
      lightBlue: '#3994D6',
      red: '#F24638'
    },
    text: {
      black: '#222222',
      grey: '#303030',
      white: '#FFFFFF'
    }
  }
};